class TiVehicleSearchContext extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.header = this.closest('.template-search__header');
    this.defaultHeader = this.header?.querySelector('[data-vehicle-search-default]');
    this.titleElement = this.querySelector('[data-vehicle-search-title]');
    this.contactLink = this.querySelector('[data-vehicle-contact]');
    this.defaultNoResults = this.header?.querySelector('[data-vehicle-no-results-default]');
    this.vehicleNoResults = this.header?.querySelector('[data-vehicle-no-results]');
    this.viewAllLink = this.header?.querySelector('[data-vehicle-view-all]');
    this.handleHistoryChange = () => this.render();

    this.dataset.initialized = 'true';
    window.addEventListener('popstate', this.handleHistoryChange);
    this.render();
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.handleHistoryChange);
  }

  normalizeText(value, maxLength) {
    const normalized = String(value || '').trim().replace(/\s+/g, ' ');
    if (!normalized || normalized.length > maxLength) return '';
    if (!/^[\p{L}\p{N}][\p{L}\p{N}\s.&/()+\-–]*$/u.test(normalized)) return '';
    return normalized;
  }

  reset() {
    this.hidden = true;
    if (this.defaultHeader) this.defaultHeader.hidden = false;
    if (this.defaultNoResults) this.defaultNoResults.hidden = false;
    if (this.vehicleNoResults) this.vehicleNoResults.hidden = true;
    if (this.viewAllLink) this.viewAllLink.hidden = true;
  }

  render() {
    this.reset();

    const params = new URLSearchParams(window.location.search);
    if (params.get('vehicle_search') !== '1' || params.get('type') !== 'product') return;

    const year = String(params.get('vehicle_year') || '').trim();
    const make = this.normalizeText(params.get('vehicle_make'), 50);
    const model = this.normalizeText(params.get('vehicle_model'), 50);
    const vehicleLabel = this.normalizeText(params.get('vehicle_label'), 100);
    const vehicleQuery = this.normalizeText(params.get('vehicle_query'), 100);
    let displayLabel = '';
    let expectedQuery = '';
    let contactVehicle = '';

    if (year || make || model) {
      const numericYear = Number(year);
      const latestAllowedYear = new Date().getFullYear() + 1;
      if (!/^\d{4}$/.test(year) || numericYear < 1900 || numericYear > latestAllowedYear || !make || !model) return;

      contactVehicle = `${make} ${model}`;
      expectedQuery = vehicleQuery || contactVehicle;
      displayLabel = `${year} ${contactVehicle}`;
    } else if (
      vehicleLabel &&
      vehicleQuery &&
      vehicleLabel.toLocaleLowerCase().includes(vehicleQuery.toLocaleLowerCase())
    ) {
      expectedQuery = vehicleQuery;
      contactVehicle = vehicleLabel;
      displayLabel = vehicleLabel;
    } else {
      return;
    }

    if (params.get('q') !== `"${expectedQuery}"`) return;

    const titleTemplate = this.dataset.titleTemplate || '';
    if (!titleTemplate.includes('__VEHICLE__') || !this.titleElement) return;

    let contactUrl;
    try {
      contactUrl = new URL(this.dataset.contactUrl || '', window.location.origin);
    } catch (_) {
      return;
    }

    if (contactUrl.origin !== window.location.origin) return;

    contactUrl.searchParams.set('topic', 'fitment');
    if (year) contactUrl.searchParams.set('year', year);
    contactUrl.searchParams.set('vehicle', contactVehicle);

    this.titleElement.textContent = titleTemplate.replace('__VEHICLE__', displayLabel);
    if (this.contactLink) {
      this.contactLink.href = `${contactUrl.pathname}${contactUrl.search}${contactUrl.hash}`;
    }

    if (this.vehicleNoResults) {
      const noResultsTemplate = this.dataset.noResultsTemplate || '';
      if (noResultsTemplate.includes('__VEHICLE__')) {
        this.vehicleNoResults.textContent = noResultsTemplate.replace('__VEHICLE__', displayLabel);
        this.vehicleNoResults.hidden = false;
        if (this.defaultNoResults) this.defaultNoResults.hidden = true;
        if (this.viewAllLink) this.viewAllLink.hidden = false;
      }
    }

    if (this.defaultHeader) this.defaultHeader.hidden = true;
    this.hidden = false;
  }
}

if (!customElements.get('ti-vehicle-search-context')) {
  customElements.define('ti-vehicle-search-context', TiVehicleSearchContext);
}
